// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as Amount$LiveRoom from "../../Amount.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";
import * as PropSpread$LiveRoom from "../PropSpread.bs.js";
import * as LoadingCard$LiveRoom from "../LoadingCard.bs.js";
import * as Utils_Shared$LiveRoom from "../../Utils/Utils_Shared.bs.js";
import * as SterlingForms$LiveRoom from "../../bindings/SterlingForms.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as Form from "@sothebys/sterling/form";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as RefetchModalContent$LiveRoom from "../RefetchModalContent.bs.js";

function formatWithCommasAndCurrency(num, curr) {
  return Utils_Shared$LiveRoom.Numbers.withCommas(String(num)) + " " + curr;
}

function ParcelModalV2$ModalLoading(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return React.createElement(LoadingCard$LiveRoom.CardContainer.make, {
              children: React.createElement("div", {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.display("grid"),
                                tl: {
                                  hd: Css.alignItems("flexStart"),
                                  tl: {
                                    hd: Css.gridTemplateColumns({
                                          hd: Css.pct(100),
                                          tl: /* [] */0
                                        }),
                                    tl: {
                                      hd: Css.gridTemplateRows({
                                            hd: Css.px(32),
                                            tl: {
                                              hd: Css.px(100),
                                              tl: {
                                                hd: Css.px(140),
                                                tl: {
                                                  hd: Css.px(32),
                                                  tl: {
                                                    hd: Css.px(32),
                                                    tl: /* [] */0
                                                  }
                                                }
                                              }
                                            }
                                          }),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }),
                          tl: {
                            hd: className$1,
                            tl: /* [] */0
                          }
                        })
                  }, React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(1, 1),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$LiveRoom.GridComponent.make, {
                            placeholderHeight: Css.px(16),
                            placeholderWidth: Css.pct(100)
                          })), React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(2, 2),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$LiveRoom.GridComponent.make, {
                            placeholderHeight: Css.px(80),
                            placeholderWidth: Css.pct(100)
                          })), React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(3, 3),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$LiveRoom.GridComponent.make, {
                            placeholderHeight: Css.px(100),
                            placeholderWidth: Css.pct(100)
                          })), React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(4, 4),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$LiveRoom.GridComponent.make, {
                            placeholderHeight: Css.px(16),
                            placeholderWidth: Css.pct(100)
                          })), React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridColumn(1, 1),
                              tl: {
                                hd: Css.gridRow(5, 5),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(LoadingCard$LiveRoom.GridComponent.make, {
                            placeholderHeight: Css.px(24),
                            placeholderWidth: Css.pct(100)
                          })))
            });
}

var ModalLoading = {
  make: ParcelModalV2$ModalLoading
};

var SelectComponent = SterlingForms$LiveRoom.Select.MakeSelect({});

function ParcelModalV2$SelectLotsDropdown(props) {
  var onSelect = props.onSelect;
  var options = Belt_Array.range(1, props.totalLotsAvailable);
  var handleSelect = function (item) {
    Curry._1(onSelect, Caml_format.int_of_string(item.value));
  };
  return React.createElement(Form.Select, {
              children: React.createElement(SelectComponent.Menu.make, {
                    children: Belt_Array.map(options, (function (num) {
                            return JsxPPXReactSupport.createElementWithKey("parcel-dropdown" + String(num), Form.Select.Item, {
                                        label: String(num),
                                        id: "parcel-dropdown" + String(num),
                                        value: String(num)
                                      });
                          }))
                  }),
              name: "AdditonalParcelToBuy",
              placeholder: String(props.value),
              onValueChange: handleSelect,
              useNativeSelectOnMobile: false
            });
}

var SelectLotsDropdown = {
  make: ParcelModalV2$SelectLotsDropdown
};

var wrapper = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent("spaceBetween"),
        tl: /* [] */0
      }
    });

function ParcelModalV2$BidDetails(props) {
  var currency = props.currency;
  var bidAmount = props.bidAmount;
  var totalNrOfLots = props.totalNrOfLots;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var totalBidAmount = Math.imul(bidAmount, totalNrOfLots);
  var formattedBidAmount = formatWithCommasAndCurrency(bidAmount, currency);
  var formattedTotalBidAmount = formatWithCommasAndCurrency(totalBidAmount, currency);
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.gridGap(Css.px(8)),
                      tl: {
                        hd: Css.flexDirection("column"),
                        tl: {
                          hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue10_nohashtag)),
                          tl: {
                            hd: Css.padding(Css.px(16)),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  })
            }, React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "parcelConfirmBidDetails"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                        className: Curry._1(Css.style, {
                              hd: Css.gridArea({
                                    NAME: "ident",
                                    VAL: "label"
                                  }),
                              tl: /* [] */0
                            }),
                        children: Curry._1(t, "ParcelConfirmBidDetails")
                      })
                }), React.createElement("div", {
                  className: wrapper
                }, React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "parcelNrOfLots"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                            children: Curry._1(t, "ParcelNrOfLots")
                          })
                    }), React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "parcelTotalNrOfLots"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                            children: String(totalNrOfLots)
                          })
                    })), React.createElement("div", {
                  className: wrapper
                }, React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "parcelBid"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                            children: Curry._1(t, "ParcelBid")
                          })
                    }), React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "parcelBidAmount"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                            children: formattedBidAmount
                          })
                    })), React.createElement("div", {
                  className: wrapper
                }, React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "parcelBidTotal"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                            children: Curry._1(t, "ParcelBidTotal")
                          })
                    }), React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "parcelTotalBidAmount"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                            children: formattedTotalBidAmount
                          })
                    })));
}

var BidDetails = {
  make: ParcelModalV2$BidDetails
};

function ParcelModalV2$Message(props) {
  var hasSubmitted = props.hasSubmitted;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "parcelWaitingMessage"
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                    className: Curry._1(Css.style, {
                          hd: Css.color(Css.hex(hasSubmitted ? SterlingTokens$LiveRoom.Colors.primaryBlue60_nohashtag : SterlingTokens$LiveRoom.Colors.alertRed60_nohashtag)),
                          tl: {
                            hd: Css.alignSelf("center"),
                            tl: /* [] */0
                          }
                        }),
                    children: hasSubmitted ? Curry._1(t, "ParcelAwaitingResponse") + "..." : Curry._1(t, "ParcelAwaitingYourResponse") + "..."
                  })
            });
}

var Message = {
  make: ParcelModalV2$Message
};

function ParcelModalV2$ButtonSection(props) {
  var setHasSubmitted = props.setHasSubmitted;
  var onOkClick = props.onOkClick;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var match$1 = React.useReducer((function (state, action) {
          if (action.TAG === /* SetIsOkLoading */0) {
            return {
                    isOkLoading: action._0,
                    isCancelLoading: state.isCancelLoading
                  };
          } else {
            return {
                    isOkLoading: state.isOkLoading,
                    isCancelLoading: action._0
                  };
          }
        }), {
        isOkLoading: false,
        isCancelLoading: false
      });
  var dispatch = match$1[1];
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.gridGap(Css.px(16)),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "parcelConfirmLotSelection"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(Button.Button, {
                        onClick: (function (param) {
                            Curry._1(dispatch, {
                                  TAG: /* SetIsOkLoading */0,
                                  _0: true
                                });
                            Curry._1(onOkClick, undefined);
                            Curry._1(setHasSubmitted, undefined);
                            Curry._1(dispatch, {
                                  TAG: /* SetIsOkLoading */0,
                                  _0: false
                                });
                          }),
                        buttonStyle: "primaryNavy",
                        disabled: props.hasSubmitted,
                        loading: match$1[0].isOkLoading,
                        children: Curry._1(match.t, "ParcelConfirmLotSelection")
                      })
                }));
}

var ButtonSection = {
  make: ParcelModalV2$ButtonSection
};

function ParcelModalV2(props) {
  var onClose = props.onClose;
  var lotId = props.lotId;
  var queryResult = Curry.app(ClientapiQueries$LiveRoom.ParcelLotModal.ParcelLotModalQuery.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        Curry._2(ClientapiQueries$LiveRoom.ParcelLotModal.ParcelLotModalQuery.makeVariables, lotId, undefined)
      ]);
  var match = Curry.app(ClientapiQueries$LiveRoom.ParcelLotModal.InterestInAdditionalParcelLots.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      ]);
  var confirmInterest = match[0];
  var match$1 = I18next$LiveRoom.useTranslation(undefined);
  var t = match$1.t;
  var match$2 = React.useReducer((function (state, action) {
          if (action.TAG === /* SetAdditionalLotsToBuy */0) {
            return {
                    additionalLotsToBuy: action._0,
                    hasSubmitted: state.hasSubmitted
                  };
          } else {
            return {
                    additionalLotsToBuy: state.additionalLotsToBuy,
                    hasSubmitted: action._0
                  };
          }
        }), {
        additionalLotsToBuy: 0,
        hasSubmitted: false
      });
  var match$3 = queryResult.data;
  var dispatch = match$2[1];
  var state = match$2[0];
  if (match$3 !== undefined) {
    var lotV2 = match$3.lotV2;
    if (lotV2 === undefined) {
      return null;
    }
    if (typeof lotV2 !== "object") {
      return null;
    }
    if (lotV2.NAME !== "LotV2") {
      return null;
    }
    var lot = lotV2.VAL;
    var currency = Amount$LiveRoom.currencyToString(Belt_Option.flatMap(lot.latestBid.bid, (function (x) {
                return x.amountV2.currency;
              })));
    var bidAmount = Belt_Option.mapWithDefault(lot.latestBid.bid, 0, (function (x) {
            return Caml_format.int_of_string(x.amountV2.amount);
          }));
    var additionalLotsAvailable = Belt_Option.mapWithDefault(lot.parcel, 0, (function (x) {
            return Belt_Option.getWithDefault(x.canSellAdditionalCount, 0);
          }));
    var noAdditionalLots = function (param) {
      Curry._8(confirmInterest, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            auctionId: lot.auction.auctionId,
            lotId: lotId,
            additionalLotsToBuy: 0
          });
    };
    return React.createElement(SterlingModal$LiveRoom.Modal.make, {
                children: React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.display("flex"),
                            tl: {
                              hd: Css.flexDirection("column"),
                              tl: {
                                hd: Css.gridGap(Css.px(24)),
                                tl: {
                                  hd: Css.margin4("zero", Css.px(40), Css.px(40), Css.px(40)),
                                  tl: /* [] */0
                                }
                              }
                            }
                          })
                    }, React.createElement(ParcelModalV2$Message, {
                          hasSubmitted: state.hasSubmitted
                        }), React.createElement(PropSpread$LiveRoom.make, {
                          data: {
                            hd: {
                              TAG: /* TestId */1,
                              _0: "parcelAdditionalLots"
                            },
                            tl: /* [] */0
                          },
                          children: React.createElement("div", {
                                className: Curry._1(Css.style, {
                                      hd: Css.display("flex"),
                                      tl: {
                                        hd: Css.flexDirection("column"),
                                        tl: {
                                          hd: Css.gridGap(Css.px(8)),
                                          tl: /* [] */0
                                        }
                                      }
                                    })
                              }, React.createElement(PropSpread$LiveRoom.make, {
                                    data: {
                                      hd: {
                                        TAG: /* TestId */1,
                                        _0: "parcelAdditionalLotsText"
                                      },
                                      tl: /* [] */0
                                    },
                                    children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                                          children: Curry._1(t, "ParcelTotalLots")
                                        })
                                  }), React.createElement(ParcelModalV2$SelectLotsDropdown, {
                                    totalLotsAvailable: additionalLotsAvailable + 1 | 0,
                                    value: state.additionalLotsToBuy + 1 | 0,
                                    onSelect: (function (value) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetAdditionalLotsToBuy */0,
                                              _0: value - 1 | 0
                                            });
                                      })
                                  }))
                        }), React.createElement(ParcelModalV2$BidDetails, {
                          totalNrOfLots: state.additionalLotsToBuy + 1 | 0,
                          bidAmount: bidAmount,
                          currency: currency
                        }), React.createElement(ParcelModalV2$ButtonSection, {
                          onOkClick: (function (param) {
                              Curry._8(confirmInterest, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
                                    auctionId: lot.auction.auctionId,
                                    lotId: lotId,
                                    additionalLotsToBuy: state.additionalLotsToBuy
                                  });
                            }),
                          setHasSubmitted: (function (param) {
                              Curry._1(dispatch, {
                                    TAG: /* SetHasSubmitted */1,
                                    _0: true
                                  });
                            }),
                          hasSubmitted: state.hasSubmitted
                        })),
                className: Curry._1(Css.style, {
                      hd: Css.width(Css.px(502)),
                      tl: /* [] */0
                    }),
                onClose: (function (param) {
                    noAdditionalLots(undefined);
                    Curry._1(onClose, undefined);
                  }),
                isOpen: true,
                headerTitle: Curry._1(t, "ParcelLotWon")
              });
  }
  if (queryResult.loading) {
    return React.createElement(SterlingModal$LiveRoom.Modal.make, {
                children: React.createElement(SterlingModal$LiveRoom.Content.make, {
                      children: React.createElement(ParcelModalV2$ModalLoading, {}),
                      className: Curry._1(Css.style, {
                            hd: Css.margin(Css.px(24)),
                            tl: /* [] */0
                          })
                    }),
                className: Curry._1(Css.style, {
                      hd: Css.width(Css.px(502)),
                      tl: /* [] */0
                    }),
                onClose: (function (param) {
                    Curry._1(onClose, undefined);
                  }),
                isOpen: true,
                headerTitle: Curry._1(t, "ParcelLotWon")
              });
  }
  if (queryResult.error !== undefined) {
    var refetch = queryResult.refetch;
    return React.createElement(SterlingModal$LiveRoom.Modal.make, {
                children: React.createElement(RefetchModalContent$LiveRoom.make, {
                      refetch: (function (eta) {
                          return Curry._3(refetch, undefined, undefined, eta);
                        }),
                      title: Curry._1(t, "ParcelLotWon")
                    }),
                className: Curry._1(Css.style, {
                      hd: Css.width(Css.px(502)),
                      tl: /* [] */0
                    }),
                onClose: (function (param) {
                    Curry._1(onClose, undefined);
                  }),
                isOpen: true,
                headerTitle: Curry._1(t, "ParcelLotWon")
              });
  }
  var refetch$1 = queryResult.refetch;
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: React.createElement(RefetchModalContent$LiveRoom.make, {
                    refetch: (function (eta) {
                        return Curry._3(refetch$1, undefined, undefined, eta);
                      }),
                    title: Curry._1(t, "ParcelLotWon")
                  }),
              className: Curry._1(Css.style, {
                    hd: Css.width(Css.px(502)),
                    tl: /* [] */0
                  }),
              onClose: (function (param) {
                  Curry._1(onClose, undefined);
                }),
              isOpen: true,
              headerTitle: Curry._1(t, "ParcelLotWon")
            });
}

var ParcelLotModalQuery = ClientapiQueries$LiveRoom.ParcelLotModal.ParcelLotModalQuery;

var InterestInAdditionalParcelLots = ClientapiQueries$LiveRoom.ParcelLotModal.InterestInAdditionalParcelLots;

var make = ParcelModalV2;

export {
  ParcelLotModalQuery ,
  InterestInAdditionalParcelLots ,
  formatWithCommasAndCurrency ,
  ModalLoading ,
  SelectComponent ,
  SelectLotsDropdown ,
  wrapper ,
  BidDetails ,
  Message ,
  ButtonSection ,
  make ,
}
/* SelectComponent Not a pure module */
